import script from "./OrderQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderQuery.vue?vue&type=script&setup=true&lang=js"

import "./OrderQuery.vue?vue&type=style&index=0&id=eb3e3676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb3e3676"]])

export default __exports__